var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSatGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1597883845"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 16095",
    d: "M7.24507 2.75245C7.41689 3.01783 7.71556 3.19344 8.05524 3.19344C8.39737 3.19344 8.69789 3.0153 8.86911 2.7467M7.24507 2.75245C7.14746 2.60169 7.09078 2.42195 7.09078 2.22898C7.09078 1.69633 7.52259 1.26453 8.05524 1.26453C8.5879 1.26453 9.0197 1.69633 9.0197 2.22898C9.0197 2.41951 8.96445 2.59713 8.86911 2.7467M7.24507 2.75245C6.52951 3.71903 6.02966 5.92077 6.02966 8.48222C6.02966 11.9358 6.93833 14.7354 8.05922 14.7354C8.67658 14.7354 9.22956 13.8862 9.6018 12.5461M8.86911 2.7467C9.15721 3.13343 9.41051 3.72019 9.61055 4.45004M9.98614 6.51339C10.0481 7.08939 10.0836 7.70253 10.0883 8.33915",
    stroke: "#CCF54E",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 16096",
    d: "M7.04707 6.72415C10.0379 4.99737 12.9169 4.38446 13.4773 5.35518C14.0222 6.29894 12.175 8.39211 9.32348 10.0945M4.22216 8.74553C3.47807 9.41961 2.94651 10.0721 2.70201 10.6203M6.24245 11.5643C5.12324 11.9587 4.15013 12.1317 3.48402 12.049M2.70201 10.6203C2.68136 10.619 2.66053 10.6183 2.63955 10.6183C2.10689 10.6183 1.67509 11.0502 1.67509 11.5828C1.67509 12.1155 2.10689 12.5473 2.63954 12.5473C3.00309 12.5473 3.31966 12.3461 3.48402 12.049M2.70201 10.6203C3.20555 10.6525 3.604 11.0711 3.604 11.5828C3.604 11.7519 3.56048 11.9109 3.48402 12.049",
    stroke: "#CCF54E",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 16097",
    d: "M6.30615 5.42138C4.47734 4.76648 3.02672 4.69511 2.646 5.35453C2.08556 6.32526 4.05581 8.51202 7.04668 10.2388C9.26665 11.5205 11.4249 12.1885 12.6192 12.0508M13.4321 10.6443C12.9199 10.6673 12.5117 11.0899 12.5117 11.6078C12.5117 11.7675 12.5505 11.9181 12.6192 12.0508M13.4321 10.6443C13.4467 10.6436 13.4614 10.6433 13.4761 10.6433C14.0088 10.6433 14.4406 11.0751 14.4406 11.6078C14.4406 12.1404 14.0088 12.5722 13.4761 12.5722C13.1032 12.5722 12.7797 12.3606 12.6192 12.0508M13.4321 10.6443C13.2395 10.1993 12.8549 9.6839 12.3187 9.1432",
    stroke: "#CCF54E",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatGroup);
export default __webpack_public_path__ + "static/media/sat_group.f5cfc43a020dbecc14cafc970878c783.svg";
export { ForwardRef as ReactComponent };